import { defineStore } from 'pinia'
import Vue from 'vue'
import { useAlertStore } from './'
import { updateStoreState, deleteStoreState, sortObjects } from '../helpers/stateUtils'
import { isNil } from 'ramda'
import { BEAM_API } from '../constants'
import i18n from '../plugins/i18n'

export const useUnitStore = defineStore({
  id: 'unit',
  state: () => ({
    units: [],
  }),
  getters: {
    findById: (state) => (id) => state.units.find(find => find.id === id),
    findByIds: (state) => (ids) => state.units.filter(find => ids.includes(find.id)),
    findByExtraId: (state) => (id) => {
      return sortObjects(state.units.filter((unit) => {
        return unit.extras.find(extra => extra === id)
      }), 'name')
    },
    findByRateId: (state) => (id) => {
      return sortObjects(state.units.filter((unit) => {
        return unit.rates.find(rate => rate === id)
      }), 'name')
    },
  },
  actions: {
    httpUpdateUnit ({ unit, args }) {
      if (isNil(args)) args = {}

      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.post(`/unit/${unit.id}`, unit)
        .then((response) => {
          updateStoreState(this.units, unit)
          if (!isNil(args.successMessage)) {
            alertStore.setAlertSuccess({ message: args.successMessage })
          }
          return response
        })
        .catch(() => {
          if (!isNil(args.errorMessage)) {
            alertStore.setAlertError({ message: args.errorMessage })
          }
        })
    },
    httpDeleteUnitThidPartyBookings ({ unit }) {
      const alertStore = useAlertStore()
      const unitStore = useUnitStore()

      return Vue.prototype.$httpEZ.delete(`${BEAM_API}/units/${unit.id}/third_party_bookings`)
        .then((response) => {
          response.data.forEach(bookingId => {
            unit.bookings = unit.bookings.filter(item => item !== bookingId)
          })

          updateStoreState(unitStore.units, unit)
          alertStore.setAlertSuccess({ message: i18n.t('manage-options.actions.delete-third-party-bookings.toast-success') })
        })
        .catch(() => {
          alertStore.setAlertError({ message: i18n.t('manage-options.actions.delete-third-party-bookings.toast-error') })
        })
    },
    httpDeleteUnit ({ unit }) {
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.delete(`/unit/${unit.id}`)
        .then(() => {
          deleteStoreState(this.units, unit.id)

          alertStore.setAlertSuccess({ message: i18n.t('manage-options.actions.delete-unit.toast-success') })
        })
        .catch(() => {
          alertStore.setAlertError({ message: i18n.t('manage-options.actions.delete-unit.toast-error') })
        })
    },
    httpImportUnitRates ({ unit, formData }) {
      const alertStore = useAlertStore()

      return Vue.prototype.$httpEZ.postForm(`${BEAM_API}/units/${unit.id}/rate_import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          updateStoreState(this.units, unit)

          alertStore.setAlertSuccess({ message: 'Unit rates have been successfully imported' })

          return response
        })
        .catch((err) => {
          let headers = err.response.headers

          if ('x-error-code' in headers) {
            const errors = JSON.parse(headers['x-error-code'])

            Object.values(errors).forEach(err => {
              alertStore.setAlertError({ message: err })
            })
          } else {
            alertStore.setAlertError({ message: 'There was a problem importing these rates' })
          }

          throw err
        })
    },
  },
})
